module.exports = __webpack_public_path__ + "img/dash-users1-img.467373cb.svg";